import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import withRouter from '../utils/with-router';
import reportTime from '../utils/reportTime';

import StickyDiv from 'react-stickydiv';

import SeoActions from '../actions/SeoActions';
import ShiftActions from '../actions/ShiftActions';
import ShiftStore from '../stores/ShiftStore';

import connectToStores from 'alt/utils/connectToStores';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Dashboard');
})
@connectToStores
@withRouter
class DashboardOverview2 extends React.Component {

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    handleScroll() {
        //let stickies = document.getElementsByClassName('sticky-container')[0];
        //
        //
        //for (var i=0; i<stickies.length; i++) {
        //    let offset = stickies[i].getBoundingClientRect();
        //
        //    if (offset.top <= 0) {
        //        stickies[i]
        //    }
        //}
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    getShifts(day) {
        let curShifts = [];
        let shifts = _.sortBy(_.filter(this.props.shifts, shift => {
                const shift_start = moment(shift.start_time).tz(shift.company.timezone).format('YYYY-MM-DD');
                return shift_start == moment(day).format('YYYY-MM-DD');
            }), shift => {
                return moment(shift.start_time).valueOf();
            });

        shifts.forEach(shift => {
            let start_time = moment(shift.start_time).tz(shift.company.timezone),
                end_time = moment(shift.end_time).tz(shift.company.timezone),
                dotClass = '';
            const isFull = shift.candidates_hired == shift.workers_needed,
                isDraft = shift.status == DJ_CONST.SHIFT_STATUSES.DRAFT,
                isCancelled = shift.status == DJ_CONST.SHIFT_STATUSES.CANCELLED,
                isCompleted = end_time < moment() || shift.status == DJ_CONST.SHIFT_STATUSES.ENDED,
                isFinished = shift.status == DJ_CONST.SHIFT_STATUSES.FINISHED,
                linkTo = isCompleted && !isFinished && !isDraft ? 'finish_shift' : 'shift',
                linkText = isFinished ? 'VIEW FINISHED SHIFT' : isCompleted && !isDraft ? 'FINISH SHIFT' : isDraft ? 'VIEW DRAFT' : isCancelled ? 'VIEW CANCELLED SHIFT' : 'VIEW DETAILS';

            // Dot color
            if(isDraft){
                dotClass = "dot-gray";
            }else if(isFull || isFinished || isCancelled) {
                dotClass = "dot-green";
            }else {
                // if published
                dotClass = "dot-orange";
            }

            curShifts.push(
                <div className="day-shift">
                    <div className= {"dot " + dotClass}></div>
                    <h4 className="shift-title">{shift.position !== null ? shift.position.name : 'Draft'}</h4>
                    <div className="shift-time">{reportTime(start_time, end_time)}</div>
                    <div className="shift-people">
                        <span className={isFull ? "people-green" : "people-gray"}>{shift.candidates_hired}{shift.workers_needed ? '/' : ''}{shift.workers_needed}</span>
                        <span className="people-orange">{shift.candidates_pending}</span>
                    </div>
                    <div className="hover-content whitebox">
                        {(shift.message_count > 0 ? <div className="shift-circle"><span>{shift.message_count}</span></div> : '')}
                        <h4 className={"shift-hover-title dot " + dotClass}>{(shift.status != 'draft' ? (shift.workers_needed + ' ' + shift.position.name + (shift.workers_needed > 1 ? 's' : '') + ' - ') : '') + shift.venue}</h4>
                        <p>Hired: {shift.candidates_hired}{shift.workers_needed ? '/' : ''}{shift.workers_needed}</p>
                        <p>Candidates: {shift.candidates_pending}</p>
                        <p>{moment(day).format('DD. MMM') + ' - ' + reportTime(start_time, end_time)}</p>
                        <Link to={linkTo} params={{shiftId: shift.id}} className="view-details">{linkText} ></Link>
                    </div>
                </div>
            );
        });

        if (moment().diff(day.clone(), 'days') <= 0) {
            curShifts.push(
                <button onClick={this.createShift.bind(this, day)} className="day-shift day-shift-new">
                    <div className="plus-sign">
                        <span>&#43;</span>
                    </div>
                </button>
            );
        }

        return curShifts;
    }

    createShift(date) {
        ShiftActions.setCreateShiftDate(moment(date).format('DD.MM.YYYY'));
        this.context.router.transitionTo('createshift');
    }

    getWeek(date, month) {
        let days = [];

        for (let i = 0; i < 7; i++) {
            let className = "day-title";
            let shifts = null;

            if (moment().startOf('day').diff(date.startOf('day'), 'days') == '0') {
                className += " today";
                shifts = this.getShifts(date);
            } else if (month.month() == date.month()) {
                shifts = this.getShifts(date);
            } else {
                className += " wrong-month";
            }

            days.push(
                <div className="day">
                    <h3 className={className}>{date.format("ddd D[.]")}</h3>
                    {shifts}
                </div>
            );

            date = date.clone();
            date.add(1, "d");
        }
        return days;
    }

    renderWeeks() {
        let weeks = [];
        let done = false;
        const DOW_MONDAY = 1;
        let date = this.props.month.clone().startOf("month").day(DOW_MONDAY);
        let monthIndex = date.month();
        let count = 0;

        while(!done) {
            weeks.push(
                <StickyDiv className={'sticky-date'} offsetTop={67} zIndex={999}>
                    <div className="week-header flag">
                        <span className="week-header-title body">
                            <div>
                                <h2 className="week-name">Week {date.week()}</h2>
                            </div>
                        </span>
                    </div>
                </StickyDiv>
            );
            weeks.push(
                <div className="week-content">
                    {this.getWeek(date.clone(), this.props.month)}
                </div>
            );
            date.add(1, "w");
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }
        return weeks;
    }

    render() {
        return (
            <div className="view-content maxwidth-wrapper">

                <div className="whitebox week">

                    <StickyDiv className={'sticky-date'}>
                        <div className="week-header flag">
                            <span className="week-header-title body">
                                <div>
                                    <button className="calendar-arrow calendar-left" onClick={this.props.prevMonth}></button>
                                    <h1 className="month-name">
                                        {this.props.month.format("MMMM, YYYY")}
                                    </h1>
                                    <button className="calendar-arrow calendar-right" onClick={this.props.nextMonth}></button>
                                </div>
                            </span>
                        </div>
                    </StickyDiv>
                    {this.renderWeeks()}
                </div>
            </div>
        );
    }
}
export default DashboardOverview2;



/** WEBPACK FOOTER **
 ** ./app/src/views/DashboardOverview2.js
 **/